import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useParams } from 'react-router-dom'; 
import './BreadcrumbBar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { EnvironmentContext } from '../../contexts/EnvironmentContext';
import logComponent from '../../common/logComponent';

export default function BreadcrumbBar() {
  const environmentContext = useContext(EnvironmentContext);
  const [path, setPath] = useState([]);
  const location = useLocation();
  const { reportId } = useParams();
  const { selectedMonitoredIndividual, selectedUnit } = environmentContext;

  useEffect(() => {
    if (logComponent('BreadcrumbBar')) { console.debug('BreadcrumbBar onMount'); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    setThisPath()
  }, []);


  useEffect(() => {
    if (logComponent('BreadcrumbBar')) { console.debug('BreadcrumbBar useEffect  [location, environmentContext.selectedMonitoredIndividual, environmentContext.selectedUnit ]'); }
    setThisPath();
  }, [location, environmentContext.selectedMonitoredIndividual, environmentContext.selectedUnit ]);


  const setThisPath = () => {
    if (logComponent('BreadcrumbBar')) { console.debug('BreadcrumbBar setThisPath'); }
    setPath(generatePath());
  }

  const getReportName = (reportId) => {
    if (logComponent('BreadcrumbBar')) { console.debug('BreadcrumbBar getReportName'); }
    switch (reportId) {
      case '2': return 'Staff Check-In Report';
      case '3': return 'Mood History Report';
      case '4': return 'Alarm History Report';
      case '5': return 'Alarm Average Response Time Report';
      default: return 'Report';
    }
  }

  const generatePath = () => {
    if (logComponent('BreadcrumbBar')) { console.debug('BreadcrumbBar generatePath'); }

    let breadcrumbPath = [];

    if (location.pathname.startsWith('/monitoredindividual')) {
      if (!selectedMonitoredIndividual) return [];

      breadcrumbPath.push({
        text: `${selectedMonitoredIndividual.legalFirstName} ${selectedMonitoredIndividual.lastName}`,
        link: `/monitoredindividual/${selectedMonitoredIndividual.monitoredIndividualId}`
      });
    } else if (location.pathname.startsWith('/unit')) {
      if (!selectedUnit) return [];

      breadcrumbPath.push({
        text: selectedUnit.name,
        link: `/unit/${selectedUnit.unitId}`
      });
    } else if (location.pathname.startsWith('/reports')) {

      breadcrumbPath.push({ text: getReportName(reportId) });
    } else if (location.pathname.startsWith('/admin')) {

      breadcrumbPath.push({
        text: 'Administration'
      });
    }

    if (location.pathname.includes('/notes')) {
      breadcrumbPath.push({ text: 'Notes history' });
    } else if (location.pathname.includes('/calendar')) {
      breadcrumbPath.push({ text: 'Event calendar' });
    } else if (location.pathname.includes('/devices')) {
      breadcrumbPath.push({ text: 'Device details' });
    } else if (location.pathname.includes('/messages')) {
      breadcrumbPath.push({ text: 'Messages' });
    } else if (location.pathname.includes('/reports') &&
      !location.pathname.startsWith('/reports')) {

      breadcrumbPath.push({ text: getReportName(reportId) });
    } else if (location.pathname.includes('/updates')) {
      breadcrumbPath.push({ text: 'New & Updated' });
    } else if (location.pathname.includes('/facilities')) {
      breadcrumbPath.push({ text: 'Facilities' });
    } else if (location.pathname.includes('/corporations')) {
      breadcrumbPath.push({ text: 'Corporations' });
    } else if (location.pathname.includes('/modules')) {
      breadcrumbPath.push({ text: 'Modules' });
    } else if (location.pathname.includes('/users')) {
      breadcrumbPath.push({ text: 'Users' });
    } else if (location.pathname.includes('/groups')) {
      breadcrumbPath.push({ text: 'Groups' });
    } else if (location.pathname.includes('/alarms')) {
      breadcrumbPath.push({ text: 'Alarm History Detail' });
    }
    return breadcrumbPath;
  }

  if (logComponent('BreadcrumbBar')) { console.debug('BreadcrumbBar rendered'); }

  return (
    path && path.length > 0 ?
      <div className="Breadcrumb-Bar">
        <div className="Breadcrumb-Bar__content">
          <Link
            to="/"
            className="Breadcrumb-Bar__home-button Breadcrumb-Bar__link-item">
            <FontAwesomeIcon icon="home" size="lg" />
          </Link>
          {
            path &&
            path.map(segment => {
              let breadcrumbItem = segment.link ?
                <Link className="Breadcrumb-Bar__link-item" to={segment.link}>{segment.text}</Link> :
                <p className="Breadcrumb-Bar__text-item">{segment.text}</p>;

              return (
                <React.Fragment key={segment.text}>
                  <FontAwesomeIcon
                    icon="chevron-right"
                    size="1x"
                    color="#ADAEB0"
                    className="Breadcrumb-Bar__path-separator" />
                  {breadcrumbItem}
                </React.Fragment>
              );
            })
          }
        </div>
      </div> :
      null
  );
}
